import { c as _c } from "react/compiler-runtime";
import type { VaultValue } from '@onefootprint/core';
import { isVaultDataBoolean, isVaultDataDocument, isVaultDataEmpty, isVaultDataEncrypted, isVaultDataNumber, isVaultDataText, isVaultDataTextArray } from '@onefootprint/core';
import type { Transforms } from '@onefootprint/types/src/data/entity';
import { CodeInline, LinkButton, Shimmer } from '@onefootprint/ui';
import { saveAs } from 'file-saver';
import { useTranslation } from 'react-i18next';
import EncryptedCell from '../encrypted-cell';
export type FieldOrPlaceholderProps = {
  data?: VaultValue;
  transforms?: Transforms;
  isLoading?: boolean;
  monospaced?: boolean;
};
const FieldOrPlaceholder = t0 => {
  const $ = _c(32);
  const {
    data,
    transforms,
    isLoading,
    monospaced
  } = t0;
  const {
    t
  } = useTranslation();
  if (isVaultDataText(data)) {
    let t1;
    if ($[0] !== data || $[1] !== monospaced) {
      t1 = monospaced ? <CodeInline size="compact" isPrivate={true}>{data}</CodeInline> : <p className="text-right break-all text-body-2 text-primary" data-dd-privacy="mask">{data}</p>;
      $[0] = data;
      $[1] = monospaced;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  if (isVaultDataNumber(data)) {
    let t1;
    if ($[3] !== data) {
      t1 = data.toString();
      $[3] = data;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    let t2;
    if ($[5] !== t1) {
      t2 = <p className="text-right break-all text-body-2 text-primary" data-dd-privacy="mask">{t1}</p>;
      $[5] = t1;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    return t2;
  }
  if (isVaultDataDocument(data)) {
    let t1;
    if ($[7] !== data.content || $[8] !== data.name) {
      t1 = () => {
        saveAs(data.content, data.name);
      };
      $[7] = data.content;
      $[8] = data.name;
      $[9] = t1;
    } else {
      t1 = $[9];
    }
    let t2;
    if ($[10] !== t) {
      t2 = t(_temp);
      $[10] = t;
      $[11] = t2;
    } else {
      t2 = $[11];
    }
    let t3;
    if ($[12] !== t1 || $[13] !== t2) {
      t3 = <LinkButton onClick={t1}>{t2}</LinkButton>;
      $[12] = t1;
      $[13] = t2;
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    return t3;
  }
  if (isVaultDataBoolean(data)) {
    let t1;
    if ($[15] !== data || $[16] !== t) {
      t1 = data ? t(_temp2) : t(_temp3);
      $[15] = data;
      $[16] = t;
      $[17] = t1;
    } else {
      t1 = $[17];
    }
    let t2;
    if ($[18] !== t1) {
      t2 = <p className="text-right text-body-2 text-primary" data-dd-privacy="mask">{t1}</p>;
      $[18] = t1;
      $[19] = t2;
    } else {
      t2 = $[19];
    }
    return t2;
  }
  if (isVaultDataTextArray(data)) {
    let t1;
    if ($[20] !== data) {
      t1 = data.join(", ");
      $[20] = data;
      $[21] = t1;
    } else {
      t1 = $[21];
    }
    let t2;
    if ($[22] !== t1) {
      t2 = <p className="text-right break-all text-body-2 text-primary" data-dd-privacy="mask">{t1}</p>;
      $[22] = t1;
      $[23] = t2;
    } else {
      t2 = $[23];
    }
    return t2;
  }
  if (Array.isArray(data) || typeof data === "object" && data !== null) {
    let t1;
    if ($[24] !== data) {
      t1 = JSON.stringify(data, null, 2);
      $[24] = data;
      $[25] = t1;
    } else {
      t1 = $[25];
    }
    let t2;
    if ($[26] !== t1) {
      t2 = <CodeInline size="compact" isPrivate={true}>{t1}</CodeInline>;
      $[26] = t1;
      $[27] = t2;
    } else {
      t2 = $[27];
    }
    return t2;
  }
  if (isLoading) {
    let t1;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Shimmer height="16px" width="90px" />;
      $[28] = t1;
    } else {
      t1 = $[28];
    }
    return t1;
  }
  if (isVaultDataEncrypted(data)) {
    const t1 = transforms?.prefix1;
    let t2;
    if ($[29] !== t1) {
      t2 = <EncryptedCell prefix={t1} />;
      $[29] = t1;
      $[30] = t2;
    } else {
      t2 = $[30];
    }
    return t2;
  }
  if (isVaultDataEmpty(data)) {
    let t1;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <p className="text-body-2">-</p>;
      $[31] = t1;
    } else {
      t1 = $[31];
    }
    return t1;
  }
  return null;
};
export default FieldOrPlaceholder;
function _temp($) {
  return $.download;
}
function _temp2($_0) {
  return $_0.yes;
}
function _temp3($_1) {
  return $_1.no;
}